import React from 'react';

import { Icons } from '@cambridgeassessment/cambridge-ui';
import { CentreBase, Consortium } from '@cambridgeassessment/lib-ee-commons';
import {
  StyledConsortiumCentres,
  StyledConsortiumGroupIcon,
  StyledCentresLinks,
  StyledFlexContainer,
} from './ConsortiumCentres.styles';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store';

interface Props {
  consortium: Consortium | undefined;
  componentNumber: string;
}

export const ConsortiumCentres = (props: Props): JSX.Element | null => {
  const { consortium, componentNumber } = props;

  const {
    samplesManagement: { sampleSearchParams },
  } = useSelector((state: RootState) => state);

  const centresFiltered: CentreBase[] | null =
    consortium?.centres.filter((x) => x.id !== sampleSearchParams?.centreId?.toUpperCase()) ?? null;

  return (
    centresFiltered && (
      <StyledConsortiumCentres>
        <StyledConsortiumGroupIcon>
          <Icons.Group />
        </StyledConsortiumGroupIcon>
        <span data-qa-id={`in-a-consortium-message-${componentNumber}`}>
          In a consortium <b>{consortium?.name}</b> with:{' '}
        </span>
        {centresFiltered.map((centre, index) => {
          const noComma = index === centresFiltered.length - 1;

          return (
            <StyledFlexContainer key={centre.id}>
              <StyledCentresLinks onClick={(e) => e.stopPropagation()}>
                <span data-qa-id={`centre-link-${componentNumber}-${centre.name}`}>
                  <b>{centre.id}</b>
                </span>
                {!noComma && <span>,</span>}
              </StyledCentresLinks>
            </StyledFlexContainer>
          );
        })}
      </StyledConsortiumCentres>
    )
  );
};
